import { render } from "./Practice.vue?vue&type=template&id=7cd08256&scoped=true"
import script from "./Practice.vue?vue&type=script&lang=js"
export * from "./Practice.vue?vue&type=script&lang=js"

import "./Practice.vue?vue&type=style&index=0&id=7cd08256&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cd08256"]])

export default __exports__